export default __webpack_public_path__ + "9a12511c423e7b8d89bb66768eb02e08.woff2";